import type { SetupStep } from "./onboardingTypes";
export function resolveSetupStep(steps: SetupStep[], selectedId?: string): SetupStep | undefined {
  const firstRequired = steps.find(step => step.required && step.state !== "done");
  const selected = steps.find(step => step.id === selectedId);
  if (selected && (!firstRequired || steps.indexOf(selected) <= steps.indexOf(firstRequired))) return selected;
  return firstRequired ?? steps.find(step => step.state !== "done");
}
